import { useContext } from 'react';
import { ElementsCoordsContext } from '@context';

export const useElementsCoordsContext = () => {
  const context = useContext(ElementsCoordsContext);
  return context;
};
